import {useCallback} from 'react';

import {PROJECT_TAGS} from '@/constants';
import {useTrackingManager} from '@/hooks';
import {TrackingEvent} from '@/services';

export const useTrackers = () => {
  const {trackEvent} = useTrackingManager();

  const trackTermsAndConditions = useCallback(
    (eventName: TrackingEvent) => {
      trackEvent(eventName, {
        project_tag: PROJECT_TAGS.ONBOARDING,
      });
    },
    [trackEvent],
  );

  return {
    trackTermsAndConditions,
  };
};
